import {URL_FILTER_PARAM} from '../../../const';
import React from 'react';
import {Icons} from '../../../../icons/icons';
import classNames from 'clsx';
import {HibuButton} from '../../../../common/hibuButton/hibuButton';
import {parseURI} from '../../../search.utils';
import {HibuFacetGroup} from '../../../../facets/facet.types';

export const constructLink = (tagGroupName: string, tagLabel: string, searchURL: string): string | undefined => {
    let filterField: string | undefined = undefined;
    if (tagGroupName === 'metadata.folder_dirPath') {
        filterField = 'metadata.folder_dirPath';
    } else if (tagGroupName === 'metadata.parentDocumentId_string') {
        filterField = 'id';
    }
    if (filterField) {
        const urlString: string = filterField + '[' + tagLabel + ']';
        const filter = parseURI(URL_FILTER_PARAM, urlString, true);
        return `${searchURL}?${filter}`;
    }
    return undefined;
};

export const getFieldNamesFromFacets = (facets: HibuFacetGroup[], startsWith: string): string[] => {
    const fieldNames: string[] = [];
    facets
        .filter(element => element.fieldName.startsWith(startsWith))
        .forEach((element) => {
            const fieldName = element.fieldName.substring(element.fieldName.indexOf('.') + 1).replace(/_.*/, '');
            fieldNames.push(fieldName);
        })
    ;
    return fieldNames;
};

export const renderActionButtons = (
    onUserValidation: () => void,
    onDelete: () => void,
    translation: any,
    userValidated?: boolean,
    validationButtonNeeded?: boolean,
    onDeleteClick?: React.MouseEventHandler
): React.JSX.Element => {
    return (
        <div className={'submit-action'}>
            {validationButtonNeeded && (
                <HibuButton
                    visible
                    className={classNames('confirm-icon', userValidated && 'user-validated')}
                    icon={userValidated ? Icons.CONFIRMED : Icons.CONFIRM}
                    onClick={onUserValidation}
                    altText={translation('search.details.confirm')}
                    disabled={userValidated}
                />
            )}
            <HibuButton
                visible
                className="delete-icon"
                icon={Icons.REMOVE}
                onClick={onDeleteClick ?? (() => onDelete())}
                altText={translation('search.details.remove')}
            />
        </div>
    );
};


